import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Card, Button, Spinner, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../config/ApiConfig';

const ChangePasswordPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { state } = location;
  const email = state?.email;
  const code = state?.code;

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/;
    return regex.test(password);
  };

  const handleChangePassword = async () => {
    if (!validatePassword(password)) {
      setError("Le mot de passe doit contenir au moins 8 caractères, une majuscule, un chiffre et un caractère spécial.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post('/update-password', {
        email,
        password,
        code
      });
      toast.success("Mot de passe modifié avec succès");
      history.push("/login");
    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.errors || err.response?.data?.message || "Erreur lors de la modification du mot de passe";
      toast.error(errorMsg);
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  if (!email || !code) {
    history.push("/forgot-password");
    return null;
  }

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <Card className="shadow" style={{ maxWidth: "500px", width: "100%" }}>
        <Card.Body className="p-5">
          <div className="text-center mb-4">
            <h2 className="mb-3">Marion Livraison</h2>
            <h4>Crée ton nouveau mot de passe</h4>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Nouveau mot de passe</Form.Label>
            <div className="position-relative">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                isInvalid={!!error}
              />
              <button
                type="button"
                className="btn btn-sm position-absolute end-0 top-50 translate-middle-y"
                onClick={() => setShowPassword(!showPassword)}
                style={{ background: "none", border: "none", zIndex: 10 }}
              >
                {showPassword ? (
                  <i className="fas fa-eye-slash"></i>
                ) : (
                  <i className="fas fa-eye"></i>
                )}
              </button>
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirmer le mot de passe</Form.Label>
            <div className="position-relative">
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setError("");
                }}
                isInvalid={!!error}
              />
              <button
                type="button"
                className="btn btn-sm position-absolute end-0 top-50 translate-middle-y"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{ background: "none", border: "none", zIndex: 10 }}
              >
                {showConfirmPassword ? (
                  <i className="fas fa-eye-slash"></i>
                ) : (
                  <i className="fas fa-eye"></i>
                )}
              </button>
            </div>
            {error && <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{error}</Form.Control.Feedback>}
          </Form.Group>

          <div className="mb-3 p-3 bg-light rounded">
            <small className="text-muted">
              <i className="fas fa-info-circle me-2"></i>
              Le mot de passe doit contenir au moins : 8 caractères, une majuscule, un chiffre et un caractère spécial
            </small>
          </div>

          <Button
            variant="primary"
            className="w-100"
            onClick={handleChangePassword}
            disabled={isLoading || !password || !confirmPassword}
          >
            {isLoading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Modification en cours...
              </>
            ) : (
              "Modifier le mot de passe"
            )}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ChangePasswordPage;
